import { FC, useEffect } from "react";
import Page from "common/components/custom/page/Page";
import { Button, Icon } from "common/components";
import commonLabelCollection from "common/config/common-keys.config";
import { useTranslation } from "react-i18next";
import { ButtonVariant } from "common/enums";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "common/config";
import { useAppDispatch } from "common/redux/core";
import { userActions } from "common/redux/user";
import { logoutImage } from "assets/media";

import "./Logout.scss";

export const LOGOUT_URLS = {
  RELOGIN: "/"
};

const Logout: FC = () => {
  const { t: tCommon } = useTranslation("common");
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.history.pushState(null, "null", window.location.href);
    window.onpopstate = function (event) {
      window.history.pushState(null, "null", window.location.href);
    };
  }, []);

  const navigateToLogin = () => {
    dispatch(userActions.hasUserLoggedOut(false));
    window.location.replace(LOGOUT_URLS.RELOGIN);
  };

  return (
    <div className="logout-wrapper">
      <div className="logout-wrapper__content">
        <Icon src={logoutImage} />
        <span className="content-title">
          {tCommon(commonLabelCollection.logoutTimeoutPageTitle)}
        </span>
        <span className="content-body">
          {tCommon(commonLabelCollection.logoutTimeoutPageContent)}
        </span>
        <Button
          variant={ButtonVariant.PRIMARY}
          size="large"
          onClick={() => {
            navigateToLogin();
          }}
        >
          {tCommon(commonLabelCollection.signIn)}
        </Button>
      </div>
    </div>
  );
};

export default Logout;
